var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"sk-folding-cube"},[_c('div',{staticClass:"sk-cube1 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube2 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube4 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube3 sk-cube"})])
}
var staticRenderFns = []

export { render, staticRenderFns }